import { ENDPOINTS } from "@/constants/endpoints"
import { HTTP_METHODS } from "@/constants/httpMethods"
import { QUERY_KEYS } from "@/constants/queryKeys"
import { useGenereicMutation } from "@/hooks/useGenericMutation"

export function useAddSkillMutation() {
  return useGenereicMutation<{ title: Array<string> }>({
    createEndpoint: () => ENDPOINTS.skills.add(),
    method: HTTP_METHODS.POST,
    invalidationKeys: [QUERY_KEYS.skills.index()],
  })
}
